import React from 'react';
import styled from 'styled-components';
import { revealBase } from '../animations';
import { useReveal } from '../hooks/useReveal';

const RevealRoot = styled.div`
  ${revealBase}
`;

export interface RevealProps extends React.HTMLAttributes<HTMLElement> {
  /** DOM tag to render. Named `tag` rather than `as`, which styled-components claims. */
  tag?: keyof React.JSX.IntrinsicElements;
  delay?: number;
}

const Reveal: React.FC<RevealProps> = ({ tag = 'div', delay = 0, children, ...rest }) => {
  const { ref, revealed } = useReveal<HTMLDivElement>(delay);

  return (
    <RevealRoot as={tag} ref={ref} data-revealed={revealed || undefined} {...rest}>
      {children}
    </RevealRoot>
  );
};

export default Reveal;
